import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const Layout: React.FC = () => (
  <div className="max-w-4xl mx-auto p-6">
    <header className="mb-8">
      <a href="/"><h1 className="text-3xl mb-4">money———machine</h1></a>
      <nav className="flex space-x-6">
        <Link to="/">Home</Link>
        <Link to="/discovery">Discovery</Link>
        <Link to="/outreach">Outreach</Link>
      </nav>
      <hr className="my-4 border-gray-300" />
    </header>
    <main>
      <Outlet />
    </main>
  </div>
);

export default Layout;
